module.exports = __webpack_public_path__ + "img/KW.b68053b7.png";